const DIGITS_ONLY = /^\d+$/
const HEX_HASH = /^[0-9a-f]{8,}$/i

// Collapse dynamic path segments (numeric ids, long hashes) so routes aggregate
// per template instead of exploding per record:
//   /users/123          -> /users/[id]
//   /accounts/9f8a2c...  -> /accounts/[id]
export const normalizeRoute = (pathname: string): string => {
  const normalized = pathname
    .split('/')
    .map((segment) => (DIGITS_ONLY.test(segment) || HEX_HASH.test(segment) ? '[id]' : segment))
    .join('/')

  return normalized || '/'
}

// Normalize a full URL's pathname; falls back to the raw string for relative or
// malformed URLs.
export const normalizeUrlPath = (url: string): string => {
  try {
    return normalizeRoute(new URL(url).pathname)
  } catch {
    return normalizeRoute(url)
  }
}
